<template>
    <div class="container-fluid">
        <div class="row mt-4 justify-content-center">
            <div class="col-12">
                <div class="card search-card border-0">
                    <div class="card-body">
                    <div class="text-center">
                        <h5 class="search-title mb-1">BUSCA TU CRÉDITO</h5>
                        <p class="search-subtitle mb-0">Por nombre de beneficiario, DNI o número de préstamo.</p>
                    </div>

                    <div class="d-flex justify-content-center mt-3" role="search">
                        <input v-model="busqueda" class="form-control buscador-input" type="search"
                            placeholder="Buscar crédito..." aria-label="Search" @keyup.enter="buscarCredito()">
                        <button class="btn btn-outline-success px-4 ms-2" @click="buscarCredito()" type="button">Buscar</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3 creditos-row">
            <div class="col-12 creditos-col">
                <div class="card border-0 search-card creditos-card">
                    <div class="card-body creditos-card-body">
                        <TablaCreditos :key="`${busquedaEnviar}`" :busqueda="busquedaEnviar" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TablaCreditos from './TablaCreditos.vue';


export default {
    data() {
        return {
            busqueda: "",
            busquedaEnviar: "",
            ready: false,
        }
    },
    beforeMount(){
        if (this.busqueda === "") {
            this.busqueda = this.obtenerDeLocalStorage('busqueda')
            this.buscarCredito()
        }
    },
    components: {
        TablaCreditos,
    },
    methods: {
        buscarCredito() {
            this.busquedaEnviar = this.busqueda
        },
        obtenerDeLocalStorage(clave) {
            // Recuperamos la cadena JSON del localStorage
            const jsonString = localStorage.getItem(clave);

            // Verificamos si hay algo almacenado en la clave dada
            if (jsonString) {
                try {
                    // Convertimos la cadena JSON de vuelta a un array de objetos
                    const arrayDeObjetos = JSON.parse(jsonString);
                    console.log('Array recuperado:', arrayDeObjetos);
                    return arrayDeObjetos;
                } catch (error) {
                    console.error('Error al convertir el JSON:', error);
                    return null;
                }
            } else {
                console.warn(`No hay datos almacenados bajo la clave "${clave}"`);
                return null;
            }
        },

    }

}
</script>

<style scoped>
.search-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    box-shadow: none;
    padding: 1.1rem;
}

.buscador-input {
    width: 50%;
    min-width: 280px;
    max-width: 540px;
}

.search-title {
    color: #173567;
    font-weight: 800;
    letter-spacing: .05em;
}

.search-subtitle {
    color: #62718b;
    font-size: .92rem;
}

.btn {
    margin: 0;
}

.btn-outline-success {
    color: #3a79ee;
    border-color: #3a79ee;
}

.btn:hover {
    margin: 0;
    background-color: #3a79ee;
    color: white;
}

.creditos-row,
.creditos-col,
.creditos-card,
.creditos-card-body {
    width: 100%;
}

.creditos-col {
    padding-right: 0;
    padding-left: 0;
}

.creditos-card {
    padding: 0;
    border-radius: 8px;
}

.creditos-card-body {
    padding: 0;
}
</style>
